<template>
  <div>
    <span
      :title="!tour.notOptimized && tour.visits.findIndex(x => x.order === null) === -1 ? $gettext('Optimized Tour 😊') : $gettext('This tour has been modified and it IS NOT optimized')"
      style="display: inline-block; width:15px; height:15px; border-radius: 0px; vertical-align: middle;"
      :class="tour.status === 'DRAFT' ? 'bg-danger' : (!tour.notOptimized && tour.visits.findIndex(x => x.order === null) === -1  ? 'bg-success' : 'bg-warning')"
      v-b-tooltip.hover
    ></span>
    <span class="text-nowrap">
      <b-link :to="{name: 'ToursEdit', params: {id: tour.id}}">{{tour.id | uuid }}</b-link>
      <a href="#" @click.prevent="copyToClipboard(tour.id)" class="text-secondary" title="Copy to Clipboard">
        <font-awesome-icon :icon="['far', 'copy']" />
      </a>
    </span>
  </div>
</template>

<script>
export default {
  name: 'ToursListItemId',
  props: {
    tour: {
      type: Object,
      default: () => {},
      required: true
    }
  }
}
</script>
